import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import identityDocuments from "../../../../../../media/images/icons/identityDocuments.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import DocumentCard from "./DocumentCard";
import CheckCircle from "../../../../../../media/images/icons/check-circle";
import CustomButton from "../../../../../components/CustomButton";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../services/fetcher";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import { useFormik } from "formik";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import { setAttachFiles } from "../../../../../../redux/features/userSlice";
export default function IdentityDocuments() {
  const [isOpen, setIsOpen] = useState(false);

  const baseImageUrl =
    process.env.NODE_ENV === "development"
      ? "https://testapibazargah.bita24.com/File?name="
      : "https://api.karentarabarnet.com/File?name=";

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { driverAttachs } = useAppSelector((state) => state.user);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const {
    trigger: getUserInfoTriggerr,
    isMutating: getUserInfoTriggerrMutating,
  } = useSWRMutation(
    [`/Driver/GetDriverUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { driverAttach1, driverAttach2, driverAttach3, driverAttach4 } =
          data;

        dispatch(
          setAttachFiles({
            driverAttach1: driverAttach1,
            driverAttach2: driverAttach2,
            driverAttach3: driverAttach3,
            driverAttach4: driverAttach4,
          })
        );
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      driverAttach1: null,
      driverAttach2: null,
      driverAttach3: null,
      driverAttach4: null,
    },
    onSubmit: (values: any) => {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });
      postAttachFiles(formData);
    },
  });

  const handleUploadFile = (file: File, title: string) => {
    formik.setFieldValue(title, file);
  };

  const { trigger: postAttachFiles, isMutating: isPostAttachFilesMutating } =
    useSWRMutation(
      [`/Account/DriverSetAttInfo`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: () => {
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("ثبت اطلاعات با موفقیت انجام شد!"));
          getUserInfoTriggerr();
        },
        onError: (e) => {
          const { data } = e.response;
          dispatch(setOpenSnackbar(true));
          dispatch(setSnackbarErrorStatus(data.errorCode));
          dispatch(setSnackbarDescription(data.error));
        },
      }
    );

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",

            gap: "4px",
          }}
        >
          <img width={32} src={identityDocuments} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              تصاویر مدارک
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کارت ملی، هوشمند، گواهینامه
            </Typography>
          </Box>
        </Box>
        <CustomButton
          justifyContent="space-between"
          onClick={() => toggleBox()}
          bgColor={isOpen ? "error.light" : theme.palette.secondary[50]}
          title={isOpen ? "بستن جزئیات" : "  مشاهده/ویرایش"}
          fSize="12px"
          fWeight="600"
          rippleColor={
            isOpen ? theme.palette.error.main : theme.palette.secondary.main
          }
          borderColor={isOpen ? "error.main" : "secondary.main"}
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="8px"
          textColor={isOpen ? "error.main" : "secondary.main"}
          icon2={
            <Box
              sx={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            >
              <ArrowDownSVG
                size={14}
                color={
                  isOpen
                    ? theme.palette.error.main
                    : theme.palette.secondary.main
                }
              />
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1500px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Divider variant="fullWidth" />
        <Box
          sx={{
            backgroundColor: theme.palette.primary[50],
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            padding: "10px",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "12px",
              textAlign: "justify",
            }}
          >
            در صورت ارسال عکس جدید از مدارک، حساب شما به حالت احرازنشده تبدیل
            می‌شود تا اپراتور بازارگاه مدارک را تایید کند.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            paddingY: "16px",
          }}
        >
          <DocumentCard
            title="driverAttach1"
            handleUploadFile={handleUploadFile}
            name="کارت ملی(صفحه رو)"
            urlAttach={
              driverAttachs?.driverAttach1
                ? `${baseImageUrl}${driverAttachs?.driverAttach1}`
                : undefined
            }
          />
          <DocumentCard
            title="driverAttach2"
            handleUploadFile={handleUploadFile}
            name="کارت ملی(صفحه پشت)"
            urlAttach={
              driverAttachs?.driverAttach2
                ? `${baseImageUrl}${driverAttachs?.driverAttach2}`
                : undefined
            }
          />
          <DocumentCard
            title="driverAttach3"
            handleUploadFile={handleUploadFile}
            name="کارت هوشمند ناوگان"
            urlAttach={
              driverAttachs?.driverAttach3
                ? `${baseImageUrl}${driverAttachs?.driverAttach3}`
                : undefined
            }
          />
          <DocumentCard
            title="driverAttach4"
            handleUploadFile={handleUploadFile}
            name="گواهینامه"
            urlAttach={
              driverAttachs?.driverAttach4
                ? `${baseImageUrl}${driverAttachs?.driverAttach4}`
                : undefined
            }
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CheckCircle size={24} color={theme.palette.success.main} />
          <Typography
            sx={{
              color: "success.main",
            }}
          >
            برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            mb: 2,
          }}
        >
          <CustomButton
            flex={1}
            justifyContent="center"
            onClick={() => {
              toggleBox();
              formik.resetForm();
            }}
            bgColor={theme.palette.primary[50]}
            title={"انصراف"}
            fSize="16px"
            fWeight="700"
            borderColor={theme.palette.primary.main}
            py="10px"
            px="6px"
            gap="4px"
            borderRadius="6px"
            textColor={theme.palette.primary.main}
          />
          <CustomButton
            loading={isPostAttachFilesMutating || getUserInfoTriggerrMutating}
            flex={1}
            justifyContent="center"
            onClick={() => {
              formik.handleSubmit();
            }}
            bgColor={"primary.main"}
            title={"ذخیره اطلاعات"}
            fSize="16px"
            fWeight="700"
            py="10px"
            px="6px"
            gap="4px"
            borderRadius="6px"
            textColor={"#fff"}
          />
        </Box>
      </Box>
    </Box>
  );
}
